import { HotTable } from '@handsontable/react';
import { RefObject, useEffect } from 'react';
import { ColWidths, MainTableType, MergeCells, NestedHeader, RowHeights, TableData } from 'src/@types/generalEnquete';
import { initialSettings } from 'src/components/app-components/bonsai/type-general-table/constants/initialSettings';
import { TABLE_NUMBER_REGEX, TABLE_SETTINGS } from 'src/generalConstants';
import { RootState, useSelector } from 'src/redux/store';
import { calcRowHeaderWidth } from 'src/utils/handsontable';

export const useNewAnswerTableData = (answerHotRef: RefObject<HotTable>[]) => {
  const totalMainTables = useSelector((state: RootState) => state.tableSetting.totalMainTables);

  // インタンス初期化共通処理
  const loadDataMainTable = (
    hr: RefObject<HotTable>,
    srcData: TableData,
    cellData: any[],
    mrgCells: MergeCells,
    cWidths: ColWidths,
    rHeights: RowHeights,
    ntdHeaders: (string | NestedHeader)[][] | undefined,
    rHeaders: string[] | undefined,
    fixCol: number | undefined,
    fixRow: number | undefined,
  ) => {
    if (hr.current) {
      const makeLoadData = srcData.map((row) => {
        return row.map((cell) => {
          return cell ?? '';
        });
      });

      hr.current.hotInstance?.loadData(makeLoadData);

      // 数値型の場合、カスタムvalidatorを設定
      const newCell = cellData.length > 0 ? JSON.parse(JSON.stringify(cellData)) : [];
      newCell.forEach((cell: any) => {
        if (cell.type === 'numeric') {
          cell.validator = function (value: any, callback: (valid: boolean) => void) {
            // 値がnullであることを許容する
            if (value === null) {
              callback(true);
            } else {
              callback(TABLE_NUMBER_REGEX.REGEX.test(value));
            }
          };
        }
      });

      hr.current.hotInstance?.updateSettings({
        ...initialSettings,
        cell: newCell,
        mergeCells: mrgCells,
        // ※rowHeights設定されていない場合、
        // DBに保存されていた値がnull（backend側はJSONで保存されるの原因）になってしまう、handsontableのスクロールが誤動作する可能性があるので、
        // rowHeightsをデフォルト値を切り替えします
        rowHeights:
          // 行高さが設定されていない場合、デフォルト値を使用
          Array.isArray(rHeights) && 0 < rHeights.length
            ? rHeights.map((height) => (height === null ? TABLE_SETTINGS.DEFAULT_ROW_HEIGHT : height)) // 行高さがnullの場合デフォルト値を使用
            : TABLE_SETTINGS.DEFAULT_ROW_HEIGHT,
        colWidths: Array.isArray(cWidths) && 0 < cWidths.length ? cWidths : 100,
        nestedHeaders: Array.isArray(ntdHeaders) && 0 < ntdHeaders.length ? ntdHeaders : undefined,
        rowHeaders: Array.isArray(rHeaders) ? rHeaders : true,
        rowHeaderWidth: calcRowHeaderWidth(rHeaders),
        fixedColumnsStart: fixCol,
        fixedRowsTop: fixRow,
      });
    }
  };

  // メイン表のインタンス初期化
  const loadDataAndUpdateSetting = () => {
    // 回答表インスタンス化
    totalMainTables.forEach((mainTable: MainTableType, index: number) => {
      loadDataMainTable(
        answerHotRef[index],
        mainTable.sourceData,
        mainTable.cell,
        mainTable.mergeCells,
        mainTable.colWidths,
        mainTable.rowHeights,
        mainTable.nestedHeaders,
        mainTable.rowHeaders,
        mainTable.fixedColumnsStart,
        mainTable.fixedRowsTop,
      );
    });
  };

  useEffect(() => {
    loadDataAndUpdateSetting();
  }, [totalMainTables]); // eslint-disable-line react-hooks/exhaustive-deps
};
